import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MessagingService {

  currentMessage = new BehaviorSubject(null);
  token: any;

  constructor(private angularFireMessaging: AngularFireMessaging) {
    this.angularFireMessaging.messages.subscribe((messaging: any) => {
      messaging.onMessage = messaging.onMessage.bind(messaging);
      messaging.onTokenRefresh = messaging.onTokenRefresh.bind(messaging);
    });
  }

  requestPermission(): any {
    this.angularFireMessaging.requestToken.subscribe(token => {
      this.setCurrentToken(token);
    }, (err) => {
      console.error('Unable to get permission to notify.', err);
    });
  }

  receiveMessage(): any {
    this.angularFireMessaging.messages.subscribe(payload => {
      this.currentMessage.next(payload);
    });
  }

  getCurrentToken(): any {
    return sessionStorage.getItem('tokenFirebase');
  }

  setCurrentToken(token: any): void {
    sessionStorage.setItem('tokenFirebase', token);
  }

}
